import { SvgIcon, SvgIconProps } from '@mui/material'

const CharacterPlus = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.031 4.25a.75.75 0 0 1 .75.751l-.019 14a.75.75 0 0 1-1.5-.002l.018-14a.75.75 0 0 1 .751-.749Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.25 12a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default CharacterPlus
